<div class="stepSpace" *ngIf="!isForm"></div>